<template>
  <a-config-provider
    :locale="locale"
    :theme="{
      token: {
        colorPrimary: '#FB6E00',
      },
    }"
  >
    <a-spin :spinning="loadingState" size="large" style="min-height: 100vh">
      <router-view />
    </a-spin>
  </a-config-provider>
</template>
<script setup>
import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { getSiteConfigApi } from "@/api/site";
import { applySeo, normalizeSiteConfig } from "@/utlis/seo";
dayjs.locale("zh-cn");
const store = useStore();
const locale = ref(zhCN);
const loadingState = computed(() => store.getters.getLoadingState);
const siteConfig = computed(() => store.getters.getSiteConfig);

watch(
  siteConfig,
  (config) => {
    applySeo(config);
  },
  { immediate: true, deep: true },
);

async function loadSiteConfig() {
  try {
    const res = await getSiteConfigApi();
    const config = normalizeSiteConfig(res);
    if (config) {
      store.commit("setSiteConfig", config);
      applySeo(config);
    }
  } catch (e) {
    console.error("加载网站配置失败", e);
  }
}

function onVisible() {
  if (document.visibilityState === "visible") {
    loadSiteConfig();
  }
}

onMounted(() => {
  loadSiteConfig();
  document.addEventListener("visibilitychange", onVisible);
});

onBeforeUnmount(() => {
  document.removeEventListener("visibilitychange", onVisible);
});
</script>

<style lang="scss"></style>
